// eslint-disable-next-line import/prefer-default-export
export function goToDiv(id) {
	const elmnt = document.getElementById(id);
	elmnt.scrollIntoView();
}
